// extracted by mini-css-extract-plugin
export default {"statistics":"SnapshotDashboard_statistics__oKU4I","statistics__dashboard":"SnapshotDashboard_statistics__dashboard__saHL7"};